<template>
  <div class="filterBar">
    <div class="filterBar__bg">
      <div class="filterBar__main container">
        <!-- employment type option -->
        <dd-single-select
          :title="$t('search.filterEmploymentType')"
          class="filterBar__main__b-filter"
          :placeholder="$t('search.selectAll')"
          :options="optionEmploymentTypeList"
          :value="employmentSingle()"
          filter-query-key="employment"
          @input="confirmSelection"
        />
        <!-- job type option -->
        <dd-multiple-lv-select
          :title="$t('search.filterJobCategory')"
          class="filterBar__main__b-filter"
          :options="optionJobTypeList"
          :value="filterQueryObject.jobType"
          filter-query-key="jobType"
          @input="confirmSelection"
          @reset="resetSelectionEvent"
        />
        <!-- district option -->
        <dd-multiple-lv-select
          :title="$t('search.filterDistrict')"
          class="filterBar__main__b-filter"
          :options="optionDistrictList"
          :value="filterQueryObject.district"
          filter-query-key="district"
          @input="confirmSelection"
          @reset="resetSelectionEvent"
        />
        <!-- working time option -->
        <dd-multiple-select
          :title="$t('search.filterWorkingTime')"
          class="filterBar__main__b-filter filterBar__main__b-filter--hidden"
          :options="optionWorkingHoursList"
          :value="filterQueryObject.workingHour"
          filter-query-key="workingHour"
          @input="confirmSelection"
          @reset="resetSelectionEvent"
        />
        <!-- working day option -->
        <dd-single-select
          :title="$t('search.filterWorkingDay')"
          class="filterBar__main__b-filter filterBar__main__b-filter--hidden"
          :placeholder="$t('search.selectAll')"
          :options="optionWorkingDayList"
          :value="filterQueryObject.workingDay"
          filter-query-key="workingDay"
          @input="confirmSelection"
        />
        <!-- monthly rate option -->
        <dd-single-select
          v-show="isShowMonthlySalary"
          :title="salaryTitle"
          class="filterBar__main__b-filter filterBar__main__b-filter--hidden"
          :placeholder="$t('search.selectAll')"
          :options="optionMonthlySalaryList"
          :value="filterQueryObject.monthlyRate"
          filter-query-key="monthlyRate"
          @input="confirmSelection"
        />
        <!-- hourly rate option -->
        <dd-single-select
          v-show="isShowHourSalary"
          :title="salaryTitle"
          class="filterBar__main__b-filter filterBar__main__b-filter--hidden"
          :placeholder="$t('search.selectAll')"
          :value="filterQueryObject.hourlyRate"
          :options="optionHourSalaryList"
          filter-query-key="hourlyRate"
          @input="confirmSelection"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MultiLevelSelectDropdown from '../dropdown/multiLevelSelectDropdown'
import MultiSelectDropdown from '../dropdown/multiSelectDropdown'
import { searchEventTypeNameMap } from '../../libs/mapping/searchParam'
import SearchFilterMixin from '../../mixins/search/filter'
import { sendFilterResetClickEvent } from '../../libs/tracking/utils/event'
import SingleSelectDropdown from '../../components/dropdown/singleSelectDropdown'

export default {
  components: {
    'dd-multiple-lv-select': MultiLevelSelectDropdown,
    'dd-multiple-select': MultiSelectDropdown,
    'dd-single-select': SingleSelectDropdown,
  },
  methods: {
    /**
     * confirm the selection value
     */
    confirmSelection(param = {}) {
      if (param.filterQueryKey === 'employment') {
        this.updateFilter(param.filterQueryKey, param.value ? [param.value] : [], this.filterPath, this.eventSource)
      } else {
        // apply filter
        this.updateFilter(param.filterQueryKey, param.value, this.filterPath, this.eventSource)
      }
    },

    /**
     * for handling mismatch between filterQueryObject.employment, single select dropdown
     */
    employmentSingle() {
      if (Array.isArray(this.filterQueryObject.employment) && this.filterQueryObject.employment.length > 0) {
        return this.filterQueryObject.employment[0]
      }

      return null
    },

    /**
     * send reset selection panel event
     */
    resetSelectionEvent(queryKey) {
      // send reset event
      sendFilterResetClickEvent(this.$eventTracker, {
        source: 'quick_filter',
        type: searchEventTypeNameMap[queryKey],
      })
    },
  },
  mixins: [SearchFilterMixin],
  props: {
    /**
     * Used for event tracking
     */
    eventSource: {
      default: '',
      type: String,
    },
    filterPath: {
      default: '',
      type: String,
    },
    filterQueryObject: {
      default: () => ({}),
      type: Object,
    },
  },
}
</script>

<style lang="postcss" scoped>
.filterBar {
  @apply sticky top-0 left-0 bg-white;
  @apply w-full;
  @apply z-10;
}
.filterBar__bg {
  @apply w-full h-full bg-white;
}
.filterBar__main {
  @apply flex items-center;
  @apply h-full mx-auto px-2;
  @apply whitespace-no-wrap;
  &:after {
    @apply absolute h-3;
    @apply pointer-events-none shadow;
    @apply left-0 bottom-0 right-0;
    z-index: -1;
    content: '';
  }
}
@screen desktop {
  .filterBar {
    height: 56px;
  }
  .filterBar__main__b-filter {
    @apply mr-2;
  }
}
@screen mobile {
  .filterBar {
    @apply h-12;
  }
  .filterBar__main {
    @apply overflow-x-auto overflow-y-hidden;
  }
  .filterBar__main__b-filter {
    @apply mr-1;
  }
  .filterBar__main__b-filter--hidden {
    @apply hidden;
  }
}
</style>
